import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./clinicWeekly.css";

export default function ScheduleModal({
  open,
  schedule,
  onClose,
  onDelete,
  readonly = false,   // ✅ thêm prop này
}) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  const fmtDateTime = (d) => {
    if (!d) return "—";
    const dt = new Date(d);
    const dd = String(dt.getDate()).padStart(2, "0");
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const yyyy = dt.getFullYear();
    const hh = String(dt.getHours()).padStart(2, "0");
    const mi = String(dt.getMinutes()).padStart(2, "0");
    return `${dd}/${mm}/${yyyy} ${hh}:${mi}`;
  };

  const caText = (b) => (b === 0 ? "Sáng" : b === 1 ? "Chiều" : "—");

  const content = (
    <div className="modal-backdrop modal-zfix" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Chi tiết lịch khám</h3>
          <button className="icon-btn" onClick={onClose}>
            ×
          </button>
        </div>

        {schedule && (
          <div className="detail-grid">
            <label>Phòng khám:</label>
            <div>{schedule.tenPhongKham || "—"}</div>

            <label>Bác sĩ:</label>
            <div>{schedule.tenBS || "—"}</div>

            <label>Điều dưỡng:</label>
            <div>{schedule.tenDD || "—"}</div>

            <label>Ca làm:</label>
            <div>{caText(schedule.buoi)}</div>

            <label>Ngày khám:</label>
            <div>{fmtDateTime(schedule.ngay)}</div>

            <label>Ghi chú:</label>
            <div>{schedule.ghiChu || "—"}</div>

            <label>Người cập nhật:</label>
            <div>{schedule.nguoi_UD || "—"}</div>

            <label>Ngày cập nhật:</label>
            <div>{fmtDateTime(schedule.ngay_UD)}</div>
          </div>
        )}

        <div className="modal-actions">
          {/* ✅ CHỈ HIỆN NÚT XÓA KHI KHÔNG READONLY */}
          {!readonly && schedule?.id && onDelete && (
            <button
              className="btn danger"
              onClick={() => onDelete(schedule.id)}
            >
              ✘ Xóa
            </button>
          )}

          <button className="btn ghost" onClick={onClose}>
            Đóng
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
}
